module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-palace-bookshelf_3fabd41.png";